(function () {
  const root = document.querySelector('.homepage-prototype');
  if (!root || root.dataset.dtCleanHomeReady === 'true') return;
  root.dataset.dtCleanHomeReady = 'true';

  const loadImportantStoryImages = () => {
    root.querySelectorAll('.innovation-card__aloe, .evidence-panel__story--science > img').forEach((image) => {
      image.loading = 'eager';
      image.decode?.().catch(() => {});
    });
  };
  window.addEventListener('scroll', loadImportantStoryImages, { once: true, passive: true });

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cartLink = root.querySelector('.header-cart');
  const cartCount = cartLink?.querySelector('[aria-live="polite"]');
  let cartRequest;

  const renderCartCount = (cart) => {
    const itemCount = Number(cart?.item_count);
    if (!cartCount || !Number.isFinite(itemCount)) return;
    cartCount.textContent = String(itemCount);
    cartLink.setAttribute('aria-label', `Cart, ${itemCount} ${itemCount === 1 ? 'item' : 'items'}`);
  };

  const refreshCartCount = () => {
    if (cartRequest) return cartRequest;
    const shopRoot = window.Shopify?.routes?.root || '/';
    cartRequest = fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart count request failed with status ${response.status}`);
        return response.json();
      })
      .then(renderCartCount)
      .catch((error) => console.warn('[Doctor Towels] Unable to refresh the header cart count.', error))
      .finally(() => { cartRequest = null; });
    return cartRequest;
  };

  const syncCartCount = (cart) => {
    if (Number.isFinite(Number(cart?.item_count))) renderCartCount(cart);
    else refreshCartCount();
  };

  document.addEventListener('cart:updated', (event) => syncCartCount(event.detail));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => syncCartCount(event?.cartData));
  }

  const openDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };

  root.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(dialog);
    });
  });

  const heroLine = root.querySelector('.hero__rotating-line');
  const heroPhrases = ['After bathing.', 'This Diwali.', 'Every day.'];
  let heroPhraseIndex = Math.max(0, heroPhrases.indexOf(heroLine?.textContent.trim()));
  if (heroLine && !prefersReducedMotion.matches) {
    const restartHeroAnimation = () => {
      heroLine.classList.remove('is-animating');
      void heroLine.offsetWidth;
      heroLine.classList.add('is-animating');
    };

    restartHeroAnimation();
    window.setInterval(() => {
      heroPhraseIndex = (heroPhraseIndex + 1) % heroPhrases.length;
      heroLine.textContent = heroPhrases[heroPhraseIndex];
      restartHeroAnimation();
    }, 3600);
  }

  const storyDialog = root.querySelector('.story-modal');
  root.querySelectorAll('.story-link').forEach((storyLink) => {
    storyLink.addEventListener('click', () => openDialog(storyDialog));
  });

  const tryDialog = root.querySelector('.try-modal');
  root.querySelectorAll('.try-today, .get-started').forEach((button) => {
    button.addEventListener('click', () => openDialog(tryDialog));
  });

  const brand = root.querySelector('.spiral-mark');
  let brandPressTimer;
  let brandCloseTimer;
  const openBrand = () => {
    window.clearTimeout(brandCloseTimer);
    brand.classList.remove('is-closing');
    brand.classList.add('is-open');
    brandCloseTimer = window.setTimeout(() => brand.classList.remove('is-open'), 3200);
  };
  brand?.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse') brandPressTimer = window.setTimeout(openBrand, 450);
  });
  ['pointerup', 'pointercancel'].forEach((name) => {
    brand?.addEventListener(name, () => window.clearTimeout(brandPressTimer));
  });

  root.querySelectorAll('.category-card').forEach((card) => {
    card.setAttribute('aria-expanded', 'false');
    card.addEventListener('click', (event) => {
      if (event.pointerType === 'mouse') return;
      const nextState = card.getAttribute('aria-expanded') !== 'true';
      root.querySelectorAll('.category-card[aria-expanded="true"]').forEach((openCard) => {
        if (openCard !== card) openCard.setAttribute('aria-expanded', 'false');
      });
      card.setAttribute('aria-expanded', String(nextState));
    });
  });

  const collectionSelector = root.querySelector('.product-gallery__selector');
  const collectionLabel = root.querySelector('#product-gallery-title');
  collectionSelector?.querySelectorAll('.product-gallery__menu button').forEach((button) => {
    button.addEventListener('click', () => {
      collectionLabel.textContent = button.textContent.trim();
      collectionSelector.removeAttribute('open');
    });
  });

  const productGalleryTabs = root.querySelectorAll('[data-product-gallery-tab]');
  const productGalleryPanels = root.querySelectorAll('.product-gallery__panel');
  productGalleryTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      productGalleryTabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
      productGalleryPanels.forEach((panel) => {
        panel.dataset.active = String(panel.id === tab.dataset.productGalleryTab);
      });
    });
  });

  const innovation = root.querySelector('.innovation');
  const innovationRail = root.querySelector('.innovation__cards');
  const innovationCards = Array.from(root.querySelectorAll('.innovation-card'));
  let innovationIndex = 0;
  let innovationTimer;
  let innovationVisible = false;
  let innovationScrollFrame;

  const activateInnovation = (index, scrollCard) => {
    innovationIndex = index;
    innovationCards.forEach((card, cardIndex) => {
      const active = cardIndex === index;
      card.classList.toggle('is-active', active);
      card.classList.toggle('is-timing', active && innovationVisible && !prefersReducedMotion.matches);
      if (active) card.setAttribute('aria-current', 'true');
      else card.removeAttribute('aria-current');
    });
    window.clearTimeout(innovationTimer);
    if (innovationVisible && !prefersReducedMotion.matches) {
      innovationTimer = window.setTimeout(() => {
        const next = (innovationIndex + 1) % innovationCards.length;
        activateInnovation(next, true);
      }, 6000);
    }
    if (scrollCard && window.matchMedia('(max-width: 900px)').matches) {
      innovationRail?.scrollTo({
        left: innovationCards[index].offsetLeft - innovationRail.offsetLeft,
        behavior: 'auto'
      });
    }
  };

  innovationCards.forEach((card, index) => {
    ['click', 'focus', 'pointerenter'].forEach((eventName) => {
      card.addEventListener(eventName, () => activateInnovation(index, false));
    });
  });

  innovationRail?.addEventListener('scroll', () => {
    if (!window.matchMedia('(max-width: 900px)').matches || innovationScrollFrame) return;
    innovationScrollFrame = window.requestAnimationFrame(() => {
      innovationScrollFrame = null;
      const railLeft = innovationRail.getBoundingClientRect().left;
      const next = innovationCards.reduce((closest, card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - railLeft);
        const closestDistance = Math.abs(innovationCards[closest].getBoundingClientRect().left - railLeft);
        return distance < closestDistance ? index : closest;
      }, 0);
      if (next !== innovationIndex) activateInnovation(next, false);
    });
  }, { passive: true });

  if (innovation && 'IntersectionObserver' in window) {
    const innovationObserver = new IntersectionObserver(([entry]) => {
      innovationVisible = entry.isIntersecting;
      activateInnovation(innovationIndex, false);
    }, { threshold: 0.24 });
    innovationObserver.observe(innovation);
  } else {
    innovationVisible = true;
    activateInnovation(0, false);
  }

  const researchDialog = root.querySelector('.explore-modal--research');
  root.querySelectorAll('.research-folder-stack, .research-global-button').forEach((button) => {
    button.addEventListener('click', () => openDialog(researchDialog));
  });

  const products = [
    {
      eyebrow: 'Most picked',
      title: 'Best of Banana Bath Towels',
      set: 'Set of 2',
      price: '₹2,698',
      rating: 4.8,
      reason: 'People start here when they want a softer everyday bath towel.',
      benefits: ['Two textures', 'Face + body zones', 'Skin Shield'],
      icons: ['iconSoft', 'iconZones', 'iconShield'],
      variant: '50624817135829'
    },
    {
      eyebrow: 'Skin-first favourite',
      title: 'Best of Aluvera Bath Towels',
      set: 'Set of 2',
      price: '₹2,798',
      rating: 4.9,
      reason: 'People choose this pair when they want a gentle feel without a heavy towel.',
      benefits: ['Aluvera fibres', 'Gentle feel', 'Quick drying'],
      icons: ['iconPlant', 'iconSoft', 'iconDry'],
      variant: '50624674234581'
    },
    {
      eyebrow: 'Best value trio',
      title: 'Ultra-Light Skincare Bath Towels',
      set: 'Set of 3',
      price: '₹3,300',
      rating: 4.7,
      reason: 'Three bath towels let people compare different materials, weights and textures at home.',
      benefits: ['Soft textures', 'Plant-based fibres', 'Quick drying'],
      icons: ['iconSoft', 'iconPlant', 'iconDry'],
      variant: '51190782722261'
    },
    {
      eyebrow: 'Fresh face rotation',
      title: 'Banana Floral Face Towels',
      set: 'Set of 4',
      price: '₹1,099',
      rating: 4.7,
      reason: 'Four small towels make a fresh face-towel rotation easier through the week.',
      benefits: ['Fresher rotation', 'Gentle on face', 'Quick drying'],
      icons: ['iconClean', 'iconSoft', 'iconDry'],
      variant: '51990786638037'
    },
    {
      eyebrow: 'Hair routine essential',
      title: 'Banana Double Cloth Hair Towels',
      set: 'Set of 2',
      price: '₹1,018.80',
      rating: 4.7,
      reason: 'The button-and-loop shape stays in place while people get ready.',
      benefits: ['Quick drying', 'Quick absorption', 'Lightweight feel'],
      icons: ['iconDry', 'iconAbsorb', 'iconSoft'],
      variant: '51747715416277'
    }
  ];

  if (tryDialog) {
    const gallery = tryDialog.querySelector('.try-modal__gallery');
    const slides = Array.from(tryDialog.querySelectorAll('.try-modal__slide'));
    const pagination = Array.from(tryDialog.querySelectorAll('.try-modal__pagination button'));
    const quantityOutput = tryDialog.querySelector('.try-modal__quantity output');
    const checkoutButton = tryDialog.querySelector('.try-modal__button--primary');
    const eyebrow = tryDialog.querySelector('.try-modal__eyebrow');
    const titleLink = tryDialog.querySelector('.try-modal__product-copy h3 a');
    const set = tryDialog.querySelector('.try-modal__set');
    const rating = tryDialog.querySelector('.try-modal__rating');
    const ratingValue = tryDialog.querySelector('.try-modal__rating-value');
    const ratingCount = tryDialog.querySelector('.try-modal__rating-count');
    const price = tryDialog.querySelector('.try-modal__price');
    const reason = tryDialog.querySelector('.try-modal__reason');
    const benefitIcons = Array.from(tryDialog.querySelectorAll('.try-modal__benefits li img'));
    const benefitLabels = Array.from(tryDialog.querySelectorAll('.try-modal__benefits li span'));
    let selectedProduct = 0;
    let quantity = 1;

    gallery?.setAttribute('aria-label', 'Recommended towel sets. Use the product controls to change selection.');

    titleLink?.addEventListener('click', () => tryDialog.close());

    const updateCheckoutSelection = () => {
      checkoutButton.dataset.variantId = products[selectedProduct].variant;
      checkoutButton.dataset.quantity = String(quantity);
    };

    const selectProduct = (index) => {
      if (!products[index]) return;
      selectedProduct = index;
      const product = products[index];
      pagination.forEach((button, buttonIndex) => {
        button.setAttribute('aria-pressed', String(buttonIndex === index));
      });
      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', String(slideIndex !== index));
      });
      const selectedSlide = slides[index];
      const reviewCount = Number(selectedSlide?.dataset.ratingCount) || 0;
      const reviewSum = Number(selectedSlide?.dataset.ratingSum) || 0;
      const productRating = reviewCount > 0 && reviewSum > 0
        ? reviewSum / reviewCount
        : Number(selectedSlide?.dataset.ratingValue) || product.rating;
      const displayedRating = productRating.toFixed(1);
      eyebrow.textContent = product.eyebrow;
      titleLink.textContent = product.title;
      titleLink.href = selectedSlide?.dataset.productUrl || '#';
      set.textContent = product.set;
      rating.setAttribute('aria-label', displayedRating + ' out of 5 stars');
      ratingValue.textContent = displayedRating;
      ratingCount.textContent = reviewCount > 0 ? '(' + reviewCount + ' reviews)' : '';
      price.textContent = product.price;
      reason.textContent = product.reason;
      benefitIcons.forEach((icon, iconIndex) => {
        icon.src = tryDialog.dataset[product.icons[iconIndex]] || icon.src;
      });
      benefitLabels.forEach((label, labelIndex) => {
        label.textContent = product.benefits[labelIndex] || '';
      });
      quantity = 1;
      quantityOutput.textContent = quantity;
      updateCheckoutSelection();
    };

    pagination.forEach((button, index) => {
      button.addEventListener('click', () => selectProduct(index));
    });

    let touchStartX = null;
    gallery?.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0]?.clientX ?? null;
    }, { passive: true });
    gallery?.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX;
      if (touchStartX === null || !Number.isFinite(touchEndX)) return;
      const distance = touchEndX - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) < 44) return;
      const nextIndex = Math.max(0, Math.min(products.length - 1, selectedProduct + (distance < 0 ? 1 : -1)));
      if (nextIndex !== selectedProduct) selectProduct(nextIndex);
    }, { passive: true });

    tryDialog.querySelector('[aria-label="Decrease quantity"]')?.addEventListener('click', () => {
      quantity = Math.max(1, quantity - 1);
      quantityOutput.textContent = quantity;
      updateCheckoutSelection();
    });
    tryDialog.querySelector('[aria-label="Increase quantity"]')?.addEventListener('click', () => {
      quantity += 1;
      quantityOutput.textContent = quantity;
      updateCheckoutSelection();
    });
    checkoutButton?.addEventListener('click', async () => {
      if (checkoutButton.dataset.quickShopPending === 'true') return;
      const label = checkoutButton.querySelector('.btn-text');
      const readyText = label?.dataset.readyText || 'Add & checkout';
      checkoutButton.dataset.quickShopPending = 'true';
      checkoutButton.disabled = true;
      checkoutButton.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Adding…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: Number(checkoutButton.dataset.variantId),
              quantity: Number(checkoutButton.dataset.quantity) || 1
            }]
          })
        });
        if (!response.ok) throw new Error('Unable to add this product');

        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('dt:cart-intent'));
        if (label) label.textContent = 'Opening GoKwik…';

        const startedAt = Date.now();
        while (typeof window.dtGokwikCheckoutClick !== 'function' && Date.now() - startedAt < 6000) {
          await new Promise((resolve) => window.setTimeout(resolve, 100));
        }
        if (typeof window.dtGokwikCheckoutClick !== 'function') throw new Error('GoKwik is not ready');

        checkoutButton.disabled = false;
        delete checkoutButton.dataset.quickShopPending;
        checkoutButton.removeAttribute('aria-busy');
        await window.dtGokwikCheckoutClick(checkoutButton);
      } catch (error) {
        checkoutButton.disabled = false;
        delete checkoutButton.dataset.quickShopPending;
        checkoutButton.removeAttribute('aria-busy');
        if (label) label.textContent = 'Retry GoKwik checkout';
        console.warn('[Doctor Towels] Quick-shop GoKwik checkout failed.', error);
        window.setTimeout(() => {
          if (label && checkoutButton.dataset.checkoutPending !== 'true') label.textContent = readyText;
        }, 3000);
      }
    });
    selectProduct(0, false);
  }

  const thoughts = [
    {
      question: 'Which side did i use for my face yesterday?',
      person: 'Rhea',
      answer: 'An ordinary towel does not give you a cue. If the same surface touches the body and then the face, oil, moisture and product residue can move with it. Clear face and body labels remove that daily guess.'
    },
    {
      question: 'why does this smell so bad??!',
      person: 'Kabir',
      answer: 'That stale smell often develops when a towel stays damp for too long. Spread it open, let it dry fully between uses and wash it regularly instead of leaving it bunched up.'
    },
    {
      question: 'am i using the same side for my b**ls and face?',
      person: 'Arjun',
      answer: 'With an ordinary towel, it is easy to lose track of which part touched the body and which part touched the face. Clearly marked zones turn that awkward question into a simple repeatable habit.'
    },
    {
      question: 'does microfibre put plastic into my skin?',
      person: 'Meera',
      answer: 'Microfibre is usually made from very fine synthetic fibres. The better-established concern is fibre shedding during washing—not a simple claim that plastic is absorbed through healthy skin. Material choice matters, but those are different mechanisms.'
    },
    {
      question: 'if my towel is dirty, how can my skincare even work??',
      person: 'Ananya',
      answer: 'Skincare goes onto the surface you create first. A clean, fully dried towel helps avoid immediately returning oil, moisture and residue to freshly washed skin. It supports the routine; it does not replace cleansing or treatment.'
    },
    {
      question: 'why does everyone claim antimicrobial?',
      person: 'Vikram',
      answer: 'Antimicrobial is a performance claim, not a reason to stop washing. Ask what was tested, under which standard, for how long, and whether the claim is about odour, protecting the fabric or a proven skin benefit.'
    },
    {
      question: 'are towel germs going back into my pores after a hot shower?',
      person: 'Nisha',
      answer: 'Heat and water do not literally open pores like doors. But rubbing freshly washed skin with a damp, reused towel can return moisture, oil and microbes to the surface—especially when the towel has not dried well.'
    }
  ];

  const thoughtTrigger = root.querySelector('.thought-trigger');
  const thoughtRegion = root.querySelector('.thought-toast-region');
  const thoughtDialog = root.querySelector('.explore-modal--thought');
  let thoughtIndex = -1;
  let toastId = 0;

  const dismissToast = (toast) => {
    if (!toast || toast.classList.contains('is-exiting')) return;
    toast.classList.add('is-exiting');
    window.setTimeout(() => toast.remove(), 680);
  };

  const openThought = (index) => {
    const thought = thoughts[index];
    if (!thought || !thoughtDialog) return;
    const prompt = "Explain this towel and skin-hygiene question in plain language: “" + thought.question + "”\n\nUse current, reliable sources. Separate established evidence from marketing claims, avoid diagnosing me, and include the practical habits that matter most.";
    thoughtDialog.innerHTML = '<article class="explore-modal__sheet thought-detail">' +
      '<form method="dialog"><button class="explore-modal__close" type="submit" aria-label="Close thought">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true"><path d="M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z"></path></svg></button></form>' +
      '<p class="explore-card__eyebrow">A thought from ' + thought.person + '</p>' +
      '<h2 id="thought-modal-title">' + thought.question + '</h2><p>' + thought.answer + '</p>' +
      '<a href="https://chatgpt.com/?prompt=' + encodeURIComponent(prompt) + '" target="_blank" rel="noreferrer">Learn with ChatGPT ' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true"><path d="M218.83,130.83l-72,72a4,4,0,0,1-5.66-5.66L206.34,132H40a4,4,0,0,1,0-8H206.34L141.17,58.83a4,4,0,0,1,5.66-5.66l72,72A4,4,0,0,1,218.83,130.83Z"></path></svg></a>' +
      '<small>Opens a prepared question. AI can make mistakes, so check its sources.</small></article>';
    openDialog(thoughtDialog);
  };

  thoughtTrigger?.addEventListener('click', () => {
    thoughtIndex = (thoughtIndex + 1) % thoughts.length;
    const currentThoughtIndex = thoughtIndex;
    const thought = thoughts[thoughtIndex];
    const toast = document.createElement('div');
    const currentToasts = Array.from(thoughtRegion.querySelectorAll('.thought-toast:not(.is-exiting)'));
    if (currentToasts.length >= 3) dismissToast(currentToasts[0]);
    toast.className = 'thought-toast';
    toast.style.setProperty('--toast-offset', '0px');
    toast.style.zIndex = String(70 - currentToasts.length);
    toast.dataset.toastId = String(++toastId);
    toast.innerHTML = '<button class="thought-toast__content" type="button"><span></span><small></small></button>' +
      '<button class="thought-toast__close" type="button" aria-label="Dismiss thought">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true"><path d="M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z"></path></svg></button>';
    toast.querySelector('span').textContent = thought.question;
    toast.querySelector('small').textContent = '— ' + thought.person + ' · Open thought →';
    toast.querySelector('.thought-toast__content').setAttribute('aria-label', 'Learn more: ' + thought.question);
    toast.querySelector('.thought-toast__content').addEventListener('click', () => openThought(currentThoughtIndex));
    toast.querySelector('.thought-toast__close').addEventListener('click', () => dismissToast(toast));
    thoughtRegion.appendChild(toast);
    const visibleToasts = Array.from(thoughtRegion.querySelectorAll('.thought-toast:not(.is-exiting)'));
    visibleToasts.forEach((item, index) => {
      const position = visibleToasts.length - 1 - index;
      item.style.setProperty('--toast-offset', (position * 124) + 'px');
      item.style.zIndex = String(70 - position);
    });
    window.setTimeout(() => dismissToast(toast), 4000);
  });
})();
